
    import {useStore} from "vuex";
import { defineComponent,computed, reactive } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
    name: "my-nav",
    props: {
        menuList: {
            type: Array,
            default: () => [],
        }
    },
    setup(props: any) {
        let subUserId:string = window.sessionStorage.getItem("subUserId")||'';
        let userCompType:string = window.sessionStorage.getItem("compType")||'';
        let menuList = props.menuList;
        const store=useStore();
        if(subUserId) menuList = menuList.filter((item:any)=>{
            if(item['subUser'] === false) return false;
            else return true
        })
        menuList = menuList.filter((item:any)=>{
            if(item['compType'] && item['compType'].indexOf(userCompType) === -1) return false;
            else return true
        })

        let state = reactive({
            menuList: menuList,
            workTotal:computed(()=>store.getters.getWorkTotal),
        });
        let router = useRouter();
        let gotoRoute = (name: any) => {
            router.push({ name });
        };
        return {
            state,
            gotoRoute,
        };
    },
});
